document.addEventListener("DOMContentLoaded", function () {
    const firstSelector = document.querySelector("[option-picker-name='Format'] .product-variant-picker__shape-swatches");

    function openDropdownAndSelect() {
        const dropdownOpener = document.querySelector(".variant-picker-dropdown__toggle");
        if (!dropdownOpener) return;
        
        dropdownOpener.click();
        
        function waitForSecondSelector(callback, attempts = 5) {
            let count = 0;
            const checkExist = setInterval(() => {
                const secondSelector = document.querySelector(".variant-picker-dropdown__body");
                if (secondSelector || count >= attempts) {
                    clearInterval(checkExist);
                    if (secondSelector) callback(secondSelector);
                }
                count++;
            }, 10);
        }

        waitForSecondSelector((secondSelector) => {
            const availableOptions = secondSelector.querySelectorAll(".variant-picker-dropdown__item:not([no-available])");
            if (availableOptions.length > 0) {
                const currentSelection = document.querySelector(".variant-picker-dropdown__item.selected");
                if (currentSelection !== availableOptions[0]) {
                    availableOptions[0].click();
                }
                dropdownOpener.click();
            }
        });
    }

    if (firstSelector) {
        firstSelector.addEventListener("click", function (event) {
            const clickedLabel = event.target.closest("label");
            if (!clickedLabel) return;
            openDropdownAndSelect();
        });
    }
});